import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ShippingPack } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShippingPackService extends TmsWebBaseEditCreateService<ShippingPack, ShippingPack> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShippingPack', $localize`Shipping Pack`, httpService, notificationService);
  }

  getForSupplier(id: string): Observable<ShippingPack[]> {
    return this.httpService.get<ShippingPack[]>(`${this.apiUrl}/GetForSupplier?id=${id}`);
  }
}
